import { render, staticRenderFns } from "./editComicChapter.vue?vue&type=template&id=85543dce&scoped=true"
import script from "./editComicChapter.vue?vue&type=script&lang=js"
export * from "./editComicChapter.vue?vue&type=script&lang=js"
import style0 from "./editComicChapter.vue?vue&type=style&index=0&id=85543dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85543dce",
  null
  
)

export default component.exports